import React from "react";
import { Modal} from "antd";
import { URL_POND, URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString, formatComma, toFixed } from "../../frameworks/Util";
import _ from "lodash";

export default function PondWeightLogModal(props) {
  const { open, onClose, target } = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();
  const columns = [
    {
      title: 'วัน - เวลา',
      dataIndex: 'created',
      key: 'created',
      width : 150,
      render : (value) => dateTimeToHumanString(value),
    },
    {
      title: 'ความสูง',
      dataIndex: 'height',
      key: 'height',
      render : (value) => <center>{value ? toFixed(value, 0) : '-'}</center>
    },
    {
      title: 'น้ำหนัก',
      dataIndex: 'weight',
      render : (value) => <center>{value ? formatComma(toFixed(value, 0)) : '-'}</center>
    },
    {
      title: 'หมายเหตุ',
      dataIndex: 'note',
      key: 'note',      
    },
    {
      title: 'ผู้บันทึก',
      dataIndex: 'created_by_name',
      key: 'created_by_name',      
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  return(
    <Modal
      title={<center>ประวัติเปลี่ยนน้ำหนัก</center>}
      open={open}
      onCancel={onClose}
      width={900}
      destroyOnClose
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_POND.POND_TRANSACTION_WEIGHT_LOG}
        hidePagination={true}
        params={{pond_transaction : target}}
      />
    </Modal>
  )
}